
import React from 'react';

import surveysStore from '../../stores/surveys'
import HierarchicalReportLayout, { formatters } from 'components/hierarchical-report/Layout'
import { SurveysReportProvider, useSurveysReportStore } from './store';

export default class SurveysReport extends HierarchicalReportLayout {
  store = surveysStore
  title = 'Surveys'

  useNewStore = () => {
    const store = useSurveysReportStore()
    return store
  }

  componentDidMount() {
    this.store.customField.fetchData()
  }

  configure = {
    filterby: {
      options: [{
        value: 'path',
        get label() {
          return <formatters.Loadable isLoading={surveysStore.path.isLoading}>Path</formatters.Loadable>
        },
        options: surveysStore.path.fetchData
      }, {
        value: 'page',
        get label() {
          return <formatters.Loadable isLoading={surveysStore.page.isLoading}>Page</formatters.Loadable>
        },
        options: surveysStore.page.fetchData
      }, {
        value: 'publisher',
        get label() {
          return <formatters.Loadable isLoading={surveysStore.publisher.isLoading}>Publisher</formatters.Loadable>
        },
        options: surveysStore.publisher.fetchData
      }, {
        value: 'allocation',
        get label() {
          return <formatters.Loadable isLoading={surveysStore.allocation.isLoading}>Allocation</formatters.Loadable>
        },
        options: surveysStore.allocation.fetchData
      }, {
        value: 'customField',
        get label() {
          return <formatters.Loadable isLoading={surveysStore.customField.isLoading}>Custom Field</formatters.Loadable>
        },
        options: surveysStore.customField.fetchData
      }, {
        value: 'pathUserProfile',
        get label() {
          return <formatters.Loadable isLoading={surveysStore.pathUserProfile.isLoading}>Path User Profile</formatters.Loadable>
        },
        options: surveysStore.pathUserProfile.fetchData
      }]
    },
    groupby: {
      default: ['customField', 'answer'],
      options: [
        { value: 'publisher', label: 'Publisher', group: 'Traffic', named: true },
        { value: 'allocation', label: 'Allocation', group: 'Traffic', named: true },
        { value: 'sid1', label: 'SubID 1', group: 'Traffic' },
        { value: 'sid2', label: 'SubID 2', group: 'Traffic' },

        { value: 'path', label: 'Path', group: 'Midpath' },
        { value: 'page', label: 'Page', group: 'Midpath' },
        { value: 'pageVersion', label: 'Page Version', group: 'Midpath' },
        { value: 'slot', label: 'Slot', group: 'Midpath' },
        { value: 'answer', label: 'Answer', group: 'Midpath' },
        { value: 'customField', label: 'Custom Field', group: 'Midpath' },
        { value: 'pathUserProfile', label: 'Path User Profile', group: 'Midpath' },
        { value: 'completedOrigin', label: 'Completed Origin', group: 'Midpath' },

        { value: 'hour', label: 'Hour', group: 'Full Time' },
        { value: 'day', label: 'Day', group: 'Full Time' },
        { value: 'month', label: 'Month', group: 'Full Time' },
        { value: 'year', label: 'Year', group: 'Full Time' },

        // { value: 'hour_unittime', label: 'Hour', group: 'Unit Time' },
        // { value: 'day_unittime', label: 'Day', group: 'Unit Time' },
        // { value: 'weekday_unittime', label: 'Weekday', group: 'Unit Time' },
        // { value: 'month_unittime', label: 'Month', group: 'Unit Time' },
      ]
    },
    metrics: {
      default: ['answeredPC', 'notAnsweredPC'],
      options: [
        { value: 'completed', label: 'Page Completed', group: 'Action' },
        { value: 'answeredPC', label: 'Answered %', group: 'Ratio' },
        { value: 'notAnsweredPC', label: 'Not Answered %', group: 'Ratio' },
      ]
    },
    sortby: {
      default: ['total desc'],
      options: [
        { value: 'total', label: 'Impressions', group: 'Default' },
      ]
    }
  }

  get columns() {
    const { metrics, groupby } = this.state || {}

    const columns = [{
      dataField: 'value',
      text: groupby && groupby.join(' / '),
      customSort: true,
      sortValue: row => row.name || row.keyString || row.value,
      formatter: formatters.name
    }, {
      dataField: 'total',
      customSort: true,
      text: "Impressions",
      formatter: formatters.drilldown(this.newTab, 'total'),
    }]

    columns.push({
      dataField: 'answered',
      customSort: true,
      text: "Answered",
      formatter: formatters.drilldown(this.newTab, 'answered')
    })

    if (metrics.includes('completed'))
      columns.push({
        dataField: 'completed',
        customSort: true,
        text: "Page Completed",
        formatter: formatters.drilldown(this.newTab, 'completed')
      })

    if (metrics.includes('answeredPC'))
      columns.push({
        dataField: 'answeredPC',
        customSort: true,
        text: "Answered (%)",
        formatter: cell => formatters.percent(cell)
      })

    columns.push({
      dataField: 'notAnswered',
      customSort: true,
      text: "Not Answered",
      formatter: formatters.drilldown(this.newTab, 'notAnswered')
    })

    if (metrics.includes('notAnsweredPC'))
      columns.push({
        dataField: 'notAnsweredPC',
        customSort: true,
        text: "Not Answered  (%)",
        formatter: cell => formatters.percent(cell)
      })

    return columns
  }

  ReportProvider = ({ children }) => <SurveysReportProvider>
    {children}
  </SurveysReportProvider>
}
